var render = function render() {
    var _vm = this, _c = _vm._self._c;
    return _c('div', {
        class: _vm.$style.container
    }, [
        _c('img', {
            attrs: {
                "src": require("@/assets/img/empty/not-found.png"),
                "alt": ""
            }
        }),
        _c('h1', [
            _vm._v("404")
        ]),
        _c('p', [
            _vm._v("您访问了不存在的页面")
        ])
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
